import React from 'react';
import { toast } from 'react-toastify';

import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { isArray, includes, isNull, isUndefined } from 'lodash';
import qs from 'querystring';

import { ONLINE } from '~/constants/default';
import { t, number } from '~/helpers';
import api from '~/services/api';

import {
  RECEBIMENTO_READ_ONLY,
  RECEBIMENTO_SELECT_TANKS,
  RECEBIMENTO_WAIT_FINISH,
} from '../Form/constantes';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function TabelaRecebimento({
  idposto,
  idproduto,
  listaDeTanques,
  onAtualizaTanques,
  status,
  onUpdateStatus,
  permitirselecionarmaisdeumtanque,
}) {
  const classes = useStyles();
  const tanksRef = React.useRef(listaDeTanques);
  const onUpdateStatusRef = React.useRef(onUpdateStatus);
  const onAtualizaTanquesRef = React.useRef(onAtualizaTanques);
  const statusRef = React.useRef(status);
  const idPostoRef = React.useRef(idposto);
  const idProdutoRef = React.useRef(idproduto);
  const requestInFlightRef = React.useRef(false);
  const lastRequestAtRef = React.useRef(0);

  React.useEffect(() => {
    tanksRef.current = listaDeTanques;
  }, [listaDeTanques]);

  React.useEffect(() => {
    onUpdateStatusRef.current = onUpdateStatus;
  }, [onUpdateStatus]);

  React.useEffect(() => {
    onAtualizaTanquesRef.current = onAtualizaTanques;
  }, [onAtualizaTanques]);

  React.useEffect(() => {
    statusRef.current = status;
  }, [status]);

  React.useEffect(() => {
    idPostoRef.current = idposto;
  }, [idposto]);

  React.useEffect(() => {
    idProdutoRef.current = idproduto;
  }, [idproduto]);

  const permitirSelecionarMultiplos = permitirselecionarmaisdeumtanque === 'S';

  function alteraValor(
    idtanquefisico,
    altura,
    volume,
    statusLocal,
    tanques,
    valordigitado
  ) {
    for (let idx = 0; idx < tanques.length; idx++) {
      if (statusLocal === RECEBIMENTO_SELECT_TANKS) {
        if (tanques[idx].idtanquefisico === idtanquefisico) {
          tanques[idx].valordigitado = valordigitado;
          tanques[idx].alturainicialdescarganftanque = altura;
          if (volume !== null) {
            tanques[idx].volumeinicialdescarganftanque = volume;
          } else {
            tanques[idx].valordigitado = 0;
          }
          onAtualizaTanques(tanques);
        }
      } else if (statusLocal === RECEBIMENTO_WAIT_FINISH) {
        if (tanques[idx].idtanquefisico === idtanquefisico) {
          tanques[idx].valordigitado = valordigitado;
          tanques[idx].alturafinaldescarganftanque = altura;
          if (volume !== null) {
            tanques[idx].volumefinaldescarganftanque = volume;
          } else {
            tanques[idx].valordigitado = 0;
          }
          onAtualizaTanques(tanques);
        }
      }
    }
  }

  // Load API tanks
  const handleGetAllTanks = React.useCallback(async () => {
    const now = Date.now();
    if (requestInFlightRef.current) {
      return;
    }

    try {
      requestInFlightRef.current = true;
      lastRequestAtRef.current = now;

      const params = {
        wherefield: ['idposto', 'idproduto', 'statustanquefisico'],
        valuewherefield: [idPostoRef.current, idProdutoRef.current, 'L'],
        typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
        orderfield: 'codigotanquefisico',
        ordination: 'asc',
      };

      const { data } = await api.get('estoquestanquespostoscomboios', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      if (statusRef.current !== RECEBIMENTO_READ_ONLY) {
        const itemsAPIById = new Map(
          data.items.map((item) => [item.idtanquefisico, item])
        );

        const updatedTanques = tanksRef.current.map((tanque) => {
          const tankAPI = itemsAPIById.get(tanque.idtanquefisico);

          if (!tankAPI) {
            return tanque;
          }

          const tanqueAtualizado = {
            ...tanque,
            statussondatanquefisico: tankAPI.statussondatanquefisico,
            capacidadeoperacionaltanquefisico:
              tankAPI.capacidadeoperacionaltanquefisico,
          };

          if (tanqueAtualizado.statussondatanquefisico === ONLINE) {
            if (statusRef.current === RECEBIMENTO_SELECT_TANKS) {
              tanqueAtualizado.alturainicialdescarganftanque =
                tankAPI.alturanivel1tanquefisico;
              tanqueAtualizado.volumeinicialdescarganftanque =
                tankAPI.volume1tanquefisico;
            } else if (statusRef.current === RECEBIMENTO_WAIT_FINISH) {
              tanqueAtualizado.alturafinaldescarganftanque =
                tankAPI.alturanivel1tanquefisico;
              tanqueAtualizado.volumefinaldescarganftanque =
                tankAPI.volume1tanquefisico;
            }
          }

          if (statusRef.current === RECEBIMENTO_WAIT_FINISH) {
            tanqueAtualizado.temperaturaambientefimdescarganftanque =
              tankAPI.temperaturamediatanquefisico;
          }

          return tanqueAtualizado;
        });

        onAtualizaTanquesRef.current(updatedTanques);
      }

      // setTanks(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      requestInFlightRef.current = false;
    }
  }, []);

  const handleGetDadosArqueacao = React.useCallback(
    async (idtanquefisico, idarqueacao, event, statusLocal, tanques) => {
      try {
        const valorDigitado = event.target.value;

        if (valorDigitado.length > 0) {
          const { data } = await api.get(
            `arqueacoes/${idarqueacao}/${idposto}/${Number(valorDigitado)}`,
            {}
          );

          alteraValor(
            idtanquefisico,
            data.altura,
            data.volume,
            statusLocal,
            tanques,
            1
          );
        } else {
          document.getElementById(`tanque_${idtanquefisico}`).value = '';
          alteraValor(idtanquefisico, 0, 0, statusLocal, tanques, 0);
        }
      } catch (err) {
        document.getElementById(`tanque_${idtanquefisico}`).value = '';
        alteraValor(idtanquefisico, 0, 0, statusLocal, tanques, 0);
        toast.error(t('s.geral.arqueacao.alturanaoexiste'));
      }
    },
    [idposto]
  );

  React.useEffect(() => {
    if (status > RECEBIMENTO_READ_ONLY) {
      onUpdateStatusRef.current();
      handleGetAllTanks();

      const intervalId = setInterval(() => {
        handleGetAllTanks();
        onUpdateStatusRef.current();
      }, 30000);

      return () => clearInterval(intervalId);
    }

    handleGetAllTanks();
  }, [status, handleGetAllTanks]);

  // const onSelectTanque = (idtanquefisico, tanques) => {
  //   for (let idx = 0; idx < tanques.length; idx++) {
  //     if (tanques[idx].idtanquefisico === idtanquefisico) {
  //       if (tanques[idx].tanqueselecionado === 1) {
  //         tanques[idx].tanqueselecionado = 0;
  //       } else {
  //         tanques[idx].tanqueselecionado = 1;
  //       }
  //       onAtualizaTanques(tanques);
  //     }
  //   }
  // };

  const onSelectTanque = (idtanquefisico, tanques) => {
    const novosTanques = tanques.map((tanque) => {
      if (tanque.idtanquefisico === idtanquefisico) {
        return {
          ...tanque,
          tanqueselecionado: tanque.tanqueselecionado === 1 ? 0 : 1,
        };
      }

      // Se for seleção única (Radio), desmarca os outros
      if (!permitirSelecionarMultiplos) {
        return { ...tanque, tanqueselecionado: 0 };
      }

      return tanque;
    });

    onAtualizaTanques(novosTanques);
  };

  return (
    <TableContainer component={Paper}>
      {/* {JSON.stringify(permitirSelecionarMultiplos)}
      {JSON.stringify(permitirselecionarmaisdeumtanque)} */}

      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Tanque</TableCell>
            <TableCell align="right">Altura Inicial</TableCell>
            <TableCell align="right">Volume Inicial</TableCell>
            <TableCell align="right">Altura Final</TableCell>
            <TableCell align="right">Volume Final</TableCell>
            <TableCell align="right">Espaço Vazio</TableCell>
            <TableCell align="right">Volume Medido</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaDeTanques.map((tanque) => (
            <TableRow key={tanque.codigotanquefisico}>
              {/* <TableCell component="th" scope="row">
                {status === RECEBIMENTO_SELECT_TANKS && (
                  <Checkbox
                    id={`check_${tanque.idtanquefisico}`}
                    checked={tanque.tanqueselecionado === 1}
                    onChange={() =>
                      onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                    }
                  />
                )}
                {tanque.codigotanquefisico}
              </TableCell> */}
              <TableCell component="th" scope="row">
                {status === RECEBIMENTO_SELECT_TANKS &&
                  (permitirSelecionarMultiplos ? (
                    <Checkbox
                      id={`check_${tanque.idtanquefisico}`}
                      checked={tanque.tanqueselecionado === 1}
                      onChange={() =>
                        onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                      }
                    />
                  ) : (
                    <Radio
                      id={`radio_${tanque.idtanquefisico}`}
                      checked={tanque.tanqueselecionado === 1}
                      onChange={() =>
                        onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                      }
                    />
                  ))}
                {tanque.codigotanquefisico}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_SELECT_TANKS &&
                  tanque.statussondatanquefisico !== ONLINE ? (
                  <TextField
                    type="number"
                    id={`tanque_${tanque.idtanquefisico}`}
                    error={
                      tanque.valordigitado === 0 &&
                      tanque.tanqueselecionado === 1
                    }
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {
                        handleGetDadosArqueacao(
                          tanque.idtanquefisico,
                          tanque.idarqueacao,
                          event,
                          status,
                          listaDeTanques
                        );
                      }
                    }}
                    onBlur={(event) => {
                      handleGetDadosArqueacao(
                        tanque.idtanquefisico,
                        tanque.idarqueacao,
                        event,
                        status,
                        listaDeTanques
                      );
                    }}
                  />
                ) : (
                  number(tanque.alturainicialdescarganftanque, 1)
                )}
              </TableCell>
              <TableCell align="right">
                {number(tanque.volumeinicialdescarganftanque, 0)}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_WAIT_FINISH &&
                  tanque.statussondatanquefisico !== ONLINE ? (
                  <TextField
                    type="number"
                    id={`tanque_${tanque.idtanquefisico}`}
                    error={tanque.valordigitado === 0}
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {
                        handleGetDadosArqueacao(
                          tanque.idtanquefisico,
                          tanque.idarqueacao,
                          event,
                          status,
                          listaDeTanques
                        );
                      }
                    }}
                    onBlur={(event) => {
                      handleGetDadosArqueacao(
                        tanque.idtanquefisico,
                        tanque.idarqueacao,
                        event,
                        status,
                        listaDeTanques
                      );
                    }}
                  />
                ) : (
                  number(tanque.alturafinaldescarganftanque, 1)
                )}
              </TableCell>
              <TableCell align="right">
                {number(tanque.volumefinaldescarganftanque, 0)}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_WAIT_FINISH
                  ? number(
                    tanque.capacidadeoperacionaltanquefisico -
                    tanque.volumefinaldescarganftanque,
                    0
                  )
                  : number(
                    tanque.capacidadeoperacionaltanquefisico -
                    tanque.volumeinicialdescarganftanque,
                    0
                  )}
              </TableCell>
              <TableCell align="right">
                {includes(
                  [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
                  status
                )
                  ? number(
                    tanque.volumefinaldescarganftanque -
                    tanque.volumeinicialdescarganftanque,
                    0
                  )
                  : 0}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
